import { Injectable, Injector } from '@angular/core'
import { BaseTrpcService } from './base-trpc.service.js'
import type { StudioRootRouter } from '@lg/backend/studio-root-router'
import { CsrfService } from './csrf.service.js'

@Injectable({
	providedIn: 'root',
})
export class StudioTrpcService extends BaseTrpcService<StudioRootRouter> {}
